(function() {
  'use strict';

  var API_BASE = 'https://fitment-api.oempartsdepartment.com/fitment';

  function init() {
    var container = document.getElementById('compatible-vehicles');
    if (!container) return;

    var contentEl = document.getElementById('compatible-vehicles-content');
    var sku = container.dataset.productSku;
    var allSkus = (window.__fitment_skus || []).slice();
    if (sku && allSkus.indexOf(sku) === -1) allSkus.unshift(sku);

    if (allSkus.length === 0) {
      contentEl.innerHTML = '<div class="compatible-vehicles__empty">No SKU data available.</div>';
      return;
    }

    var uniqueSkus = allSkus.filter(function(s, i) { return allSkus.indexOf(s) === i; });

    Promise.all(uniqueSkus.map(function(s) {
      return fetch(API_BASE + '/vehicles?sku=' + encodeURIComponent(s))
        .then(function(res) { return res.json(); })
        .catch(function() { return { vehicles: [] }; });
    })).then(function(results) {
      var allVehicles = [];
      results.forEach(function(r) {
        if (r.vehicles) allVehicles = allVehicles.concat(r.vehicles);
      });

      if (allVehicles.length === 0) {
        contentEl.innerHTML = '<div class="compatible-vehicles__empty">No compatible vehicles found for this part.</div>';
        return;
      }

      var grouped = groupVehicles(allVehicles);
      renderVehicles(contentEl, grouped);
    }).catch(function() {
      contentEl.innerHTML = '<div class="compatible-vehicles__empty">Unable to load compatible vehicles.</div>';
    });
  }

  function groupVehicles(vehicles) {
    var makes = {};
    vehicles.forEach(function(v) {
      if (!makes[v.make]) makes[v.make] = {};
      if (!makes[v.make][v.model]) makes[v.make][v.model] = new Set();
      makes[v.make][v.model].add(v.year);
    });

    var result = [];
    Object.keys(makes).sort().forEach(function(make) {
      var models = [];
      var totalYears = 0;
      Object.keys(makes[make]).sort().forEach(function(model) {
        var years = Array.from(makes[make][model]).sort().reverse();
        totalYears += years.length;
        models.push({ name: model, years: years });
      });
      result.push({ make: make, models: models, totalYears: totalYears });
    });
    return result;
  }

  function renderVehicles(el, groups) {
    var totalVehicles = 0;
    groups.forEach(function(g) { totalVehicles += g.totalYears; });

    var html = '';

    if (groups.length > 3) {
      html += '<button class="compatible-vehicles__toggle-all" id="cv-toggle-all">Expand All</button>';
    }

    groups.forEach(function(group, gi) {
      var isOpen = groups.length <= 3;
      html += '<div class="compatible-vehicles__group">';
      html += '<div class="compatible-vehicles__make" data-cv-toggle="cv-models-' + gi + '">';
      html += '<span class="compatible-vehicles__make-arrow' + (isOpen ? ' open' : '') + '">&#9654;</span>';
      html += group.make;
      html += '<span class="compatible-vehicles__count">' + group.models.length + ' model' + (group.models.length !== 1 ? 's' : '') + '</span>';
      html += '</div>';
      html += '<div class="compatible-vehicles__models' + (isOpen ? ' open' : '') + '" id="cv-models-' + gi + '">';

      group.models.forEach(function(model) {
        html += '<div class="compatible-vehicles__model-group">';
        html += '<div class="compatible-vehicles__model-name">' + model.name + '</div>';
        html += '<div class="compatible-vehicles__years">';
        model.years.forEach(function(year) {
          html += '<span class="compatible-vehicles__year">' + year + '</span>';
        });
        html += '</div></div>';
      });

      html += '</div></div>';
    });

    el.innerHTML = html;

    el.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-cv-toggle]');
      if (toggle) {
        var targetId = toggle.dataset.cvToggle;
        var target = document.getElementById(targetId);
        var arrow = toggle.querySelector('.compatible-vehicles__make-arrow');
        if (target) {
          target.classList.toggle('open');
          if (arrow) arrow.classList.toggle('open');
        }
      }

      if (e.target.id === 'cv-toggle-all') {
        var allModels = el.querySelectorAll('.compatible-vehicles__models');
        var allArrows = el.querySelectorAll('.compatible-vehicles__make-arrow');
        var anyOpen = Array.from(allModels).some(function(m) { return m.classList.contains('open'); });
        allModels.forEach(function(m) {
          if (anyOpen) m.classList.remove('open'); else m.classList.add('open');
        });
        allArrows.forEach(function(a) {
          if (anyOpen) a.classList.remove('open'); else a.classList.add('open');
        });
        e.target.textContent = anyOpen ? 'Expand All' : 'Collapse All';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
